import React from "react";
import "../styles/LandingPage.css";

const LandingPage = () => {

    return (
        <div className="container landing d-flex justify-content-center align-items-center">
            <div>
                <h1 className="landing-name">DALLAS</h1>
                <p className="landing-role">JUNIOR DEVELOPER — WEB, APP, SOFTWARE</p>
                <div className="studying">
                    <p className="studying-label">STUDYING AT</p>
                    <a
                        href="https://www.ynov.com/campus/paris"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                    <img
                        src="https://brand.ynov.com/img/logos/villes/paris/logo_ynov_campus_paris_white.svg"
                        alt="logo Ynov Paris"
                        width="120"
                        height="auto"
                        style={{ marginTop: "2vh" }}
                    />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
